import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Guard from 'components/access-control/rbac/Guard';
import { PRIV } from 'components/access-control/rbac/privileges';
import React from 'react'
import { Button, Card } from 'react-bootstrap';

export const HeaderSection = ({ navigate, status, id, setShowModal }) => {
  return (
    <Card className="mb-4 shadow-none mt-3 rounded border-1">
      <Card.Body className="d-flex align-items-center py-3 px-4 flex-wrap">
        {/* Left side: Back button */}
        <div className="d-flex align-items-center" style={{ minWidth: 90 }}>
          <Button
            type="button"
            onClick={() => navigate("/olitask/donations/credit-applications")}
            size="sm"
            aria-label="Go back"
            variant="outline-success"
          >
            <span style={{ fontSize: "1.3em", lineHeight: 1 }}>←</span> Back
          </Button>
        </div>

        {/* Center: Title */}
        <div className="px-3">
          <h4 className="mb-0 fw-semibold text-base">
            Credit application details
          </h4>
        </div>

        {/* Right side: Action buttons */}
        <div className="flex-1 d-flex mt-3 mt-sm-0 align-items-center justify-content-sm-end gap-2">
          {status === "PENDING" && (
            <Guard privilege={PRIV.APPROVE_APPLICATIONS}>
              <Button
                variant="success"
                size="sm"
                onClick={() => setShowModal(true)}
                className="text-nowrap text-xs"
              >
                Approve
                <FontAwesomeIcon
                  icon="check"
                  transform="shrink-2"
                  className="ms-1"
                />
              </Button>
            </Guard>
          )}

          {status !== "PENDING" && (
            <Guard privilege={PRIV.ISSUE_CREDIT}>
              <Button
                variant="success"
                size="sm"
                onClick={() =>
                  navigate(
                    `/olitask/donations/credit-application/${id}/issue-credit`
                  )
                }
                className="text-nowrap text-xs"
              >
                Issue Credit
                <FontAwesomeIcon
                  icon="check"
                  transform="shrink-2"
                  className="ms-1"
                />
              </Button>
            </Guard>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
